import tpaPostMessageCommon from './common/tpaPostMessageCommon'

export {tpaPostMessageCommon}
